import React from "react";
import { useNavigate } from "react-router-dom";
import Transition from "./Transition";
import { AnimatePresence } from "framer-motion";

export default function CardLoader({ errorMessage = null, onRetry }) {

    const navigate = useNavigate();

    return (
        <div
            className="card custom-card card-primary position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center bg-opacity-75"
            style={{ zIndex: 10 }}
        >
            {!errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={"loader"}>
                        <div className="spinner-border text-primary" role="status"></div>
                    </Transition>
                </AnimatePresence>
            ) : (
                <>
                    <AnimatePresence mode="wait">
                        <Transition key={"card-loader-error"}>
                            <div className="form-input-content text-center ">
                                <h1 className="error-text fw-bold">{errorMessage.code}</h1>
                                <h4><i className="fa fa-times-circle text-danger"></i> {errorMessage.message}</h4>
                                <p>Your Request resulted in an error</p>
                                <div className="d-flex justify-content-center gap-2">
                                    <button className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2" onClick={onRetry}>
                                        <i className="fas fa-sync-alt"></i> Reload
                                    </button>
                                    <button className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2" onClick={() => navigate(-1)}>
                                        <i className="fas fa-arrow-left"></i> Go Back
                                    </button>
                                </div>
                            </div>
                        </Transition>
                    </AnimatePresence>
                </>
            )}
        </div>
    );
}